import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { domainActions } from '../../../store/domainStore';
import { Formik, Form } from 'formik';
import { isEqual } from 'lodash';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { searchActions } from '../../../store/searchStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import BbDatePicker from "../../common/datePicker";
import BbInput from "../../styling/bbInput";
import classnames from 'classnames'
import moment from 'moment';
import PopupMultiSelectButton from '../../common/popupMultiSelectButton';
import SearchTip from '../../common/searchTip';

class BussinesBulletinSearchForm extends React.Component {
    state = { showWarning: false }

    initialValues = {
        searchFor: '',
        recordType: {
            all: [],
            parent: [],
            allSelected: false
        },
        dateFrom: '',
        dateTo: '',
        bulletinNumber: ''
    }

    changeWarning(show) {
        this.setState({ showWarning: show });
    }

    render() {
        return (
            <div className="content-root-narrow">
                <Formik
                    ref={(el) => this.formRef = el}
                    initialValues={this.initialValues}
                    onSubmit={(values, { setSubmitting }) => { setSubmitting(false); this.submitSearch(values, false) }}
                >
                    {({ values, setFieldValue, setValues }) => (
                        <Form style={{ width: "100%" }}>
                            <SearchTip windowId={`tips_business_bulletin`} getSearchTipsModel={this.getSearchTipsModel} style={{ marginBottom: '-0.5em', marginTop: '1em' }} />
                            <div className='card card-special' style={{ paddingTop: "1.5em" }}>
                                <div className='card-body'>
                                    <BbInput label={this.props.translate('Search.BusinessBulletin.SearchForm.Search')} name="searchFor" type="text"
                                        placeholder={{ type: 'column' }} />
                                    <BbInput label={this.props.translate('Search.BusinessBulletin.SearchForm.RecordType')} type='custom' placeholder={{ type: 'column' }}
                                        custom={
                                            <PopupMultiSelectButton
                                                data='bulletin-record-types'
                                                name='recordType'
                                                popupSize='large'
                                                title={this.props.translate('Search.BusinessBulletin.SearchForm.RecordType')}
                                                onClick={() => this.props.ensureDomainDataByMarketAttribute('bulletin-record-types')}
                                                selection={values.recordType}
                                                handleChange={(all, parent) => setFieldValue('recordType', { all: all, parent: parent })}
                                            />
                                        }
                                    />
                                    <div className='field bb-field'>
                                        <div className="columns">
                                            <div className="column is-4 bb-input-label-column">
                                                <div className="bankruptcy-label">
                                                    <Translate id="Search.BusinessBulletin.SearchForm.DateFrom" />
                                                </div>
                                            </div>
                                            <div className="column is-4">
                                                <div className="bankruptcy-date">
                                                    <BbDatePicker formik={this.formRef} field={'dateFrom'} value={values.dateFrom}
                                                        placeholder={this.props.translate("Report.Common.From")} formDateFormat={"YYYY-MM-DD"}
                                                        yearsBack={120}
                                                    />
                                                </div>
                                            </div>
                                            <div className="column is-4">
                                                <div className="bankruptcy-date">
                                                    <BbDatePicker formik={this.formRef} field={'dateTo'} value={values.dateTo}
                                                        placeholder={this.props.translate("Report.Common.To")} formDateFormat={"YYYY-MM-DD"}
                                                        yearsBack={120}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <BbInput label={this.props.translate('Search.BusinessBulletin.SearchForm.BulletinNumber')} name="bulletinNumber"
                                        type="text" placeholder={{ type: 'column' }} />
                                    <div className='has-text-centered' style={{ padding: "0.5em 0px 1.5em" }}>
                                        {this.state.showWarning && <div className="column is-narrow" >
                                            <b><Translate id='Search.Bulletin.SearchForm.WarningFillIn' /></b>
                                        </div>}
                                        <div className='column is-narrow' style={{ paddingLeft: 0, paddingRight: 0 }}>
                                            <button className={classnames('bb-button is-primary gradient-1-secondary', { 'is-square': localStorage.locales_button_style === 'square' })} style={{ fontWeight: 600 }} type="button" disabled={this.props.isSearching}
                                                onClick={() => this.submitSearch(values, true)}
                                            >
                                                <Translate id="Search.Bulletin.SearchForm.LatestRecords" />
                                            </button>
                                            <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} style={{ fontWeight: 600 }} type="submit" disabled={this.props.isSearching}>
                                                <Translate id="Search.Common.Search" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        )
    }

    submitSearch(values, latest) {
        if (!latest && isEqual(values, this.initialValues)) {
            this.changeWarning(true);
            return;
        }
        this.changeWarning(false);
        var fd = this.getSearchFormData(values, latest);
        this.props.history.push({ pathname: `${this.props.path}/results`, state: fd });
    }

    getSearchFormData(values, latest) {
        var codes = [];
        if (values.recordType.all != undefined) {
            for (var i = 0; i < values.recordType.all.length; i++)
                codes.push(values.recordType.all[i].value);
        }

        return {
            searchText: values.searchFor,
            recordTypeList: codes,
            dateFrom: isNullOrUndefined(values.dateFrom) || values.dateFrom === "" ? null : moment(values.dateFrom).format("YYYY-MM-DD"),
            dateTo: isNullOrUndefined(values.dateTo) || values.dateTo === "" ? null : moment(values.dateTo).format("YYYY-MM-DD"),
            bulletinNumber: values.bulletinNumber,
            latest: latest
        }
    }

    getSearchTipsModel = () => {
        return { title: `${this.props.translate('Search.BusinessBulletin.SectionNameSPZ')}`, bodyHtml: this.props.translate('SearchTips.Bulletin.Body') };
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state, search: state.search }),
    dispatch => bindActionCreators({ ...searchActions, ...domainActions }, dispatch),
)(BussinesBulletinSearchForm)));